import { useState } from 'react';

const faqItems = [
  {
    q: '向日葵视频是否需要注册或付费？',
    a: '完全不需要！向日葵视频所有影视资源均免费在线观看，无需注册账号，无需购买会员，打开网站即可直接播放。我们坚持自由开放的观影理念，让每一位用户都能无障碍享受高清影视内容。',
  },
  {
    q: '播放卡顿或加载失败怎么办？',
    a: '向日葵视频采用多线路智能调度技术，如果遇到播放卡顿，可以尝试切换播放线路。同时建议检查网络连接，使用Wi-Fi或5G网络可获得更流畅的观看体验。榴莲视频、红杏视频等热门内容均有多条备用线路保障。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '向日葵视频完美适配电脑、平板、手机等所有设备，无需下载任何APP。我们提供标清、高清、1080P及4K超清多种画质选择，根据你的网络环境智能推荐最佳画质，确保流畅不缓冲的观影体验。',
  },
  {
    q: '剧集更新频率如何？能同步热播吗？',
    a: '向日葵视频每日同步更新最新影视内容，热门剧集一般在播出后24小时内即可在线观看。我们密切关注榴莲视频、红杏视频等平台的更新动态，确保你不错过任何精彩剧集。电影、综艺、动漫同样保持高频更新节奏。',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            关于向日葵视频的常见疑问，这里都有解答
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4 font-heading">
                  {item.q}
                </h3>
                <span
                  className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg transition-colors duration-200 ${
                    openIdx === idx
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200/70 text-foreground-500'
                  }`}
                >
                  <i
                    className={`text-sm transition-transform duration-300 ${
                      openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}